// extracted by mini-css-extract-plugin
module.exports = {"QuizParaContainer":"QuizParagraph_QuizParaContainer__3FfOX","QuizHeading":"QuizParagraph_QuizHeading__3moYK","QuizPara":"QuizParagraph_QuizPara__32HwP"};